$(document).on('click', '.js-clear-change-password-form-fields-btn', function(){
    $('.js-current-password-form-field').val('').attr('type', 'password').siblings('.btn-eye-password').removeClass('visible');
});

function validateChangePasswordForm(){
    const form = document.querySelector('.js-change-password-form');
    const passwordInput = document.querySelector('.js-change-password-field');
    const passwordError = document.querySelector('.js-change-password-sign');
    const passwordCurrentInput = document.querySelector('.js-current-password-field');
    const passwordCurrentError = document.querySelector('.js-current-password-sign');
    
    let passwordDefaultState = true;
    let passwordCurrentDefaultState = true;
    
    $(passwordInput).on('blur', function(){
        if($(this).val() != '' && passwordDefaultState == true){
            passwordDefaultState = false;
            validatePassword(passwordInput, passwordError);
        }
    });

    $(passwordCurrentInput).on('blur', function(){
        if($(this).val() != '' && passwordCurrentDefaultState == true){
            passwordCurrentDefaultState = false;
            validateCurrentPassword();
        }
    });

    passwordInput.addEventListener('input', () => {
        if(!passwordDefaultState){
            validatePassword(passwordInput, passwordError);
        }
    });

    passwordCurrentInput.addEventListener('input', () => {
        if(!passwordCurrentDefaultState){
            validateCurrentPassword();
        }
    });
    
    function validateCurrentPassword(){
        const password = passwordCurrentInput.value.trim();
    
        if (password != currentPassword) {
            showErrorMessage(passwordCurrentError, 'Entered incorrect password');
            return false;
        }

        hideErrorMessage(passwordCurrentError);
        return true;
    }

    $(form).submit(function(e) {
        e.preventDefault();
    
        if (validateCurrentPassword() && validatePassword(passwordInput, passwordError)) {
            $(this).off('submit').on('submit', function(){
                return true;
            });
            $(this)[0].submit();
        } else {
            console.log('Validation failed');
        }
    });
}

runIfElementExist(validateChangePasswordForm, '.js-change-password-form');



